import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchAnnouncementsDone = (_, { payload }) => {
  
  return [
    ...payload,
  ];
};

const saveAnnouncementDone = (announcements, { payload }) => {
  return [
    ...announcements,
    payload,
  ];
}

const deleteAnnouncementDone = (announcements,{ payload }) =>{
  return announcements.filter( c => c.id !== payload)
}

const clearAnnouncementsDone = () => {
  return initialState
}
const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_ANNOUNCEMENTS_DONE]: fetchAnnouncementsDone,
  [TYPES.SAVE_ANNOUNCEMENTS_DONE]: saveAnnouncementDone,
  [TYPES.DELETE_ANNOUNCEMENTS_DONE]:deleteAnnouncementDone,
  [TYPES.CLEAR_ANNOUNCEMENTS_DONE]: clearAnnouncementsDone
});
